import {
  FormControl,
  FormHelperText,
  SxProps,
  Theme,
  InputLabel,
  MenuItem,
  Select,
  BaseTextFieldProps,
  Chip,
  Box,
} from '@mui/material'
import { FC } from 'react'
import { Control, Controller, FieldError } from 'react-hook-form'
import { isColorDark } from '../../utils/isColorDark'

interface Option {
  label: string
  value: string | number
  color: string
}

type Props = {
  sx?: SxProps<Theme>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any, any>
  error: FieldError | undefined
  label?: string
  fieldName: string
  options: Array<Option>
  requiredRule: string | undefined
  size?: BaseTextFieldProps['size']
  disabled?: boolean
}

export const MemberStatusSelectField: FC<Props> = ({
  sx,
  control,
  options,
  error,
  fieldName,
  label,
  requiredRule,
  size,
  disabled,
}) => {
  const labelId = `${fieldName}_label`

  return (
    <FormControl fullWidth variant="outlined" sx={sx} required={Boolean(requiredRule)}>
      <InputLabel htmlFor={labelId} error={!!error} size={size === 'small' ? 'small' : 'normal'}>
        {label}
      </InputLabel>
      <Controller
        name={fieldName}
        control={control}
        rules={{ required: requiredRule }}
        defaultValue={''}
        render={({ field: { onChange, value } }) => (
          <Select
            value={value}
            onChange={onChange}
            label={label}
            labelId={labelId}
            error={!!error}
            required={Boolean(requiredRule)}
            size={size}
            disabled={disabled}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {options.map(
                  (option) =>
                    // Find the corresponding option object based on the value
                    selected === option.value && (
                      // If an option is found, use its label; otherwise, use the value as a fallback
                      <Chip
                        key={option.value}
                        label={option.label}
                        // Used this dirty hack to fix the padding of the select to be the same as the other inputs
                        sx={{
                          marginY: '-4.5px !important',
                          backgroundColor: option.color ?? 'white',
                          color: isColorDark(option.color ?? 'white') ? 'white' : 'black',
                        }}
                      />
                    )
                )}
              </Box>
            )}
          >
            {options.map((option) => (
              <MenuItem value={option.value} key={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />

      <FormHelperText error={!!error}>{error?.message}</FormHelperText>
    </FormControl>
  )
}
